import { useMergeAppConfigSecrets } from "core/hooks/useMergeAppConfigSecrets";
import { FunctionComponent, PropsWithChildren } from "react";

import { QueryStateIndicator } from "../common/ui-components/QueryStateIndicator";
import {
  ComponentCode,
  TenantFeaturesCode
} from "./gateways/plt-catalog/plt-catalog.dtos";
import {
  usePltCatalogPracticeLicences,
  usePltcCatalogComponent,
  useTenantFeatures
} from "./gateways/plt-catalog/plt-catalog.hooks";
import { useCurrentUserQuery } from "./gateways/user/user.hooks";

export const CoreDataFetcher: FunctionComponent<PropsWithChildren> = ({
  children
}) => {
  const userQuery = useCurrentUserQuery();
  const { isLoading: isTenantFeatureLoading, error: tenantFeatureError } =
    useTenantFeatures(TenantFeaturesCode.prosBhbIntegration);

  const {
    isLoading: isPltCatalogPracticeLicencesLoading,
    error: pltCatalogPracticeLicencesError
  } = usePltCatalogPracticeLicences();

  const { isLoading: isTenantComponentLoading, error: tenantComponentError } =
    usePltcCatalogComponent(ComponentCode.bpmIntegration);

  const { isLoading: isLoadingConfig, error: configError } =
    useMergeAppConfigSecrets();

  return (
    <QueryStateIndicator
      loadingTitle="Loading your profile, please wait..."
      isLoading={
        isTenantFeatureLoading ||
        userQuery.isLoading ||
        isPltCatalogPracticeLicencesLoading ||
        isTenantComponentLoading ||
        isLoadingConfig
      }
      error={
        tenantFeatureError ??
        userQuery.error ??
        pltCatalogPracticeLicencesError ??
        tenantComponentError ??
        configError
      }
      data={userQuery.data}
    >
      {children}
    </QueryStateIndicator>
  );
};
